<script>
  import { untrack } from 'svelte'
  import { useForm } from '@inertiajs/svelte'
  import { liveValidate } from '../../lib/live_validation.svelte.js'
  import Drawer from '../drawer.svelte'
  import TextField from '../form/text_field.svelte'
  import SelectField from '../form/select_field.svelte'
  import ToggleField from '../form/toggle_field.svelte'
  import SubmitButton from '../form/submit_button.svelte'

  // The campaign form's feed "Create New" (old CMS Content step drawer): creates a standard
  // feed in the campaign's town without leaving the campaign. The server makes it a standard,
  // everyone, always-on feed in the town's time zone (FeedsController#with_quick_create_defaults),
  // validates live (Precognition, `feed.*` keys) and answers with the feed as flash data (the
  // picker's option shape) or its errors in the `quick_feed` error bag.
  let { open = $bindable(false), areaOptions = [], areaId = null, oncreated } = $props()

  const blank = () => ({ name: '', display_name: '', area_id: '', active: true, manual_ranking_enabled: false })

  const form = useForm({ quick_create: true, feed: blank() }).withPrecognition('post', '/feeds')
  const live = liveValidate(form, 'feed')

  $effect(() => {
    if (!open) return
    untrack(() => {
      $form.feed = { ...blank(), area_id: areaId ?? '' }
      $form.clearErrors()
      live.reset()
    })
  })

  const error = (key) => $form.errors[`feed.${key}`]

  const submit = (event) => {
    event.preventDefault()
    $form.post('/feeds', {
      preserveState: true,
      preserveScroll: true,
      only: ['flash'],
      errorBag: 'quick_feed',
      onFlash: ({ created_feed: createdFeed }) => {
        if (!createdFeed) return
        oncreated?.(createdFeed)
        open = false
      }
    })
  }
</script>

<Drawer bind:open title="Create New Feed">
  <form novalidate onsubmit={submit} class="space-y-4">
    <TextField bind:value={$form.feed.name} label="Name" name="quick_feed_name" error={error('name')} />
    <TextField bind:value={$form.feed.display_name} label="Display Name" name="quick_feed_display_name" error={error('display_name')} />
    <SelectField bind:value={$form.feed.area_id} label="College Town" name="quick_feed_area_id" options={areaOptions} error={error('area_id')} />
    <ToggleField bind:checked={$form.feed.active} label="Active" name="quick_feed_active" error={error('active')} />
    <ToggleField
      bind:checked={$form.feed.manual_ranking_enabled}
      label="Manual Ranking"
      name="quick_feed_manual_ranking_enabled"
      help="When enabled, content is manually ordered by its position value."
    />

    {#if error('base') || error('schedule_attributes')}<p class="text-sm text-error">{error('base') || error('schedule_attributes')}</p>{/if}

    <SubmitButton processing={$form.processing} label="Create feed" />
  </form>
</Drawer>
